import setShowReadingPane from '../actions/setShowReadingPane';
import { lazySaveReadingPaneOption } from 'owa-reading-pane-option';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import { action } from 'satcheljs/lib/legacy';
/**
 * Initializes show reading pane
 */
export default action('initializeShowReadingPane')(function initializeShowReadingPane() {
    var globalReadingPanePosition = getUserConfiguration().UserOptions
        .GlobalReadingPanePositionReact;
    switch (globalReadingPanePosition) {
        case ReadingPanePosition.Off:
            setShowReadingPane(false);
            break;
        case ReadingPanePosition.Right:
        case ReadingPanePosition.Bottom:
            setShowReadingPane(true);
            break;
        default:
            // Fall back to ReadingPanePosition.Off if user has other reading pane position set
            lazySaveReadingPaneOption.importAndExecute(ReadingPanePosition.Off /* newReadingPanePosition */);
            break;
    }
});
//# sourceMappingURL=initializeShowReadingPane.js.map